module.exports = __webpack_public_path__ + "img/logo-small.7ff7b814.png";